<div class="modal-container">
  <div class="data-container">
    <div class="title-wrapper">
      <p>Are you sure you want to delete all these redis keys?</p>
      <button
        type="button"
        class="btn-modal-header"
        (click)="onDismiss('cancel')"
        data-dismiss="modal">
        <span class="ti ti-close"></span>
      </button>
    </div>
    <div class="content-wrapper">
      <div class="mt-4">
        <div class="input-line">
          <div>
            <span><b>Key</b></span>
          </div>
          <div>
            <p>{{ keys.join(', ') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="btns-containers">
      <button class="default-4" (click)="onDismiss('cancel')">Cancel</button>
      <button class="default-1" (click)="onConfirm()">
        Permanently delete
      </button>
    </div>
  </div>
</div>
